var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Show component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShow extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.60547 11.9998C2.60547 11.7275 2.69533 11.4768 2.84048 11.2941C3.64034 10.3262 4.93733 8.91717 6.548 7.7547C8.16737 6.58595 10.0391 5.71289 12.0005 5.71289C13.9619 5.71289 15.8336 6.58595 17.453 7.7547C19.0637 8.91717 20.3606 10.3262 21.1605 11.2941C21.3056 11.4768 21.3955 11.7275 21.3955 11.9998C21.3955 12.2722 21.3056 12.5229 21.1605 12.7056C20.3606 13.6735 19.0637 15.0825 17.453 16.245C15.8336 17.4137 13.9619 18.2868 12.0005 18.2868C10.0391 18.2868 8.16737 17.4137 6.548 16.245C4.93732 15.0825 3.64033 13.6735 2.84047 12.7056C2.69532 12.5229 2.60547 12.2722 2.60547 11.9998ZM12.0005 4.21289C9.59906 4.21289 7.42067 5.27499 5.67016 6.53839C3.91356 7.80619 2.52248 9.32363 1.68009 10.3435L1.68003 10.3435L1.67334 10.3518C1.30152 10.8153 1.10547 11.4031 1.10547 11.9998C1.10547 12.5966 1.30152 13.1844 1.67334 13.6479L1.67328 13.6479L1.68009 13.6562C2.52248 14.6761 3.91356 16.1935 5.67016 17.4613C7.42067 18.7247 9.59906 19.7868 12.0005 19.7868C14.4019 19.7868 16.5803 18.7247 18.3308 17.4613C20.0874 16.1935 21.4785 14.6761 22.3209 13.6562L22.321 13.6562L22.3277 13.6478C22.6994 13.1844 22.8955 12.5966 22.8955 11.9998C22.8955 11.4031 22.6994 10.8153 22.3277 10.3519L22.3278 10.3519L22.3209 10.3435C21.4785 9.32363 20.0874 7.80619 18.3308 6.53839C16.5803 5.27499 14.4019 4.21289 12.0005 4.21289ZM11.8897 8.38379C9.74822 8.38379 8.01221 10.1198 8.01221 12.2613C8.01221 14.4028 9.74822 16.1388 11.8897 16.1388C14.0312 16.1388 15.7672 14.4028 15.7672 12.2613C15.7672 10.1198 14.0312 8.38379 11.8897 8.38379ZM9.51221 12.2613C9.51221 10.9482 10.5766 9.88379 11.8897 9.88379C13.2028 9.88379 14.2672 10.9482 14.2672 12.2613C14.2672 13.5743 13.2028 14.6388 11.8897 14.6388C10.5766 14.6388 9.51221 13.5743 9.51221 12.2613Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconShow.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShow.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconShow.prototype, "size", void 0);
if (customElements.get('cat-icon-show') === undefined) {
    customElements.define('cat-icon-show', BlocksIconShow);
}
